import { Route, Routes } from "react-router-dom";
import AboutUsPage from "../app/components/company/about-us";
import PricingPage from "../app/components/company/pricing";
import ServicesPage from "../app/components/IT solutions/services/services";
import ServicesDetailPage from "../app/components/IT solutions/services/detail";
import ContactUsPage from "../app/components/contactus/contact-us";
import Home1Page from "../app/components/home/index";
import WebDevDetailsPage from "../app/components/IT solutions/services/WebDevDetailsPage";
import DigitalMarketingServicePage from "../app/components/IT solutions/services/DigitalMarketingServicePage";
import MobileAppDevelopmentServicePage from "../app/components/IT solutions/services/MobileAppDevelopmentServicePage";

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home1Page />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/detail" element={<ServicesDetailPage />} />
        <Route
          path="/services/web-development/"
          element={<WebDevDetailsPage />}
        />
        <Route
          path="/services/digital-marketing"
          element={<DigitalMarketingServicePage />}
        />
        <Route
          path="/services/mobile-app-development"
          element={<MobileAppDevelopmentServicePage />}
        />
        <Route path="/contact-us" element={<ContactUsPage />} />
        {/* <Route path="/gallery" element={<GalleryPage />} /> */}
        {/* <Route path="/team" element={<TeamPage />} /> */}
        {/* <Route path="/faq" element={<FAQPage />} /> */}
        {/* <Route path="/icons" element={<IconsPage />} /> */}
        {/* <Route path="/testimonials" element={<TestimonialsPage />} />
                  <Route path="/why-choose-us" element={<WhyChooseUsPage />} /> */}
        {/* <Route path="/mission" element={<MissionVisionPage />} /> */}
        {/* <Route path="/portfolio" element={<Portfolio1Page />} /> */}
        {/* <Route path="/portfolio2" element={<Portfolio2Page />} /> */}
        {/* <Route path="/portfolio/detail" element={<PortfolioDetailPage />} />
                <Route path="/blogs" element={<BlogGridPage />} />
                <Route path="/blogs/list" element={<BlogListSidebarPage />} />
                <Route path="/blogs/detail-with-sidebar" element={<BlogDetailSidebarPage />} />
                <Route path="/blogs/detail" element={<BlogDetailPage />} /> */}
      </Routes>
    </>
  );
}

export default AppRoutes;
